import React from 'react';
import cx from 'classnames';
import styles from './rssFeedDetailView.module.scss';
import { 
    FormGroup, InputGroup, FormControl
} from 'react-bootstrap';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button/index';

class RssFeedDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      urlError: ''
    }

    this._handleChange = this._handleChange.bind(this);
    this._handleCancel = this._handleCancel.bind(this);
    this._handleSave = this._handleSave.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;

  }

  componentDidMount() {
   
  }

  _handleChange(e){
    this.props.onChange(e);
  }

  _handleCancel(){
    this.props.onCancel();
  }

  _handleSave(){
    this.props.onSave();
  }

  render() {
    return (
        <div className={cx(styles.content)} >  
            <div className={styles.inner}>
                <FormGroup className={cx(styles.formGroup)}>
                   <InputGroup>
                        <div className={styles.start}>
                        <span className={styles.title}>{this.localizedContentSources.rss_feed.title}</span>
                        </div>
                        <FormControl
                        type='text'
                        placeholder={this.localizedContentSources.rss_feed.placeholder}
                        value={this.state.rssFeedUrl}
                        onChange={this._handleChange}
                        />
                    </InputGroup>
                </FormGroup>
                {this.props.urlError &&
                  <p className={styles.errorMessage}>{this.localizedContentSources.rss_feed.error_message}</p>
                }
            </div>
            <div className={styles.buttonActions}>
            <Button
                text={this.localizedCommonActions.save}
                variant='primary'
                className={styles.confirm}
                onClick={this._handleSave}
                >
            </Button>
            <Button
                text={this.localizedCommonActions.cancel}
                variant='secondary'
                className={cx(styles.updateAction, styles.cancel)}
                onClick={this._handleCancel} />
            </div>
        </div>  
    );
  }
}

export default RssFeedDetailView;    